import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useHistory, useRouteMatch, Switch, Route, Redirect, useParams } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import AdminPage from '../../admin/shared/AdminPage'
import SydTabs from '../../../commonDesign/SydTabs'
import SchedulerHome from './SchedulerHome'
import ScheduleDetail from './ScheduleDetail'
import ScheduleForm from './ScheduleForm'
import UnmanagedSchedules from './UnmanagedSchedules'
import UnmanagedScheduleDetail from './UnmanagedScheduleDetail'
import TargetListing from './TargetListing'
import ScheduleFireHistory from './ScheduleFireHistory'

const MANAGEMENT_TABS = {
  managed: { label: 'Managed Schedules', value: 'managed' },
  unmanaged: { label: 'Unmanaged Schedules', value: 'unmanaged' },
  targets: { label: 'Targets', value: 'targets' },
  history: { label: 'Fire History', value: 'history' }
}

const SECTION_COMPONENTS = {
  managed: SchedulerHome,
  unmanaged: UnmanagedSchedules,
  targets: TargetListing,
  history: ScheduleFireHistory
}

function ScheduleManagementTabs ({ section }) {
  const { url } = useRouteMatch()
  const history = useHistory()

  const handleTabChange = useCallback((value) => {
    const base = url.replace(/\/(managed|unmanaged|targets|history)$/, '')
    history.replace(`${base}/${value}`)
  }, [history, url])

  const SectionComponent = SECTION_COMPONENTS[section] || SchedulerHome

  return (
    <AdminPage>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SydTabs.Group
            key={section}
            tabOptions={MANAGEMENT_TABS}
            defaultValue={section}
            onChange={handleTabChange}
          >
            <SydTabs.MiniList />
          </SydTabs.Group>
        </Grid>
        <Grid item xs={12}>
          <SectionComponent />
        </Grid>
      </Grid>
    </AdminPage>
  )
}

ScheduleManagementTabs.propTypes = {
  section: PropTypes.string.isRequired
}

function ScheduleManagement () {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/managed/new`} exact>
        <ScheduleForm />
      </Route>
      <Route path={`${path}/managed/:scheduleId/edit`} exact>
        <ScheduleForm />
      </Route>
      <Route path={`${path}/managed/:scheduleId/:tab?`}>
        <ScheduleDetail />
      </Route>
      <Route path={`${path}/unmanaged/:scheduleName`}>
        <UnmanagedScheduleDetail />
      </Route>
      <Route path={`${path}/:section(managed|unmanaged|targets|history)`}>
        <ScheduleManagementTabsRouter />
      </Route>
      <Redirect to={`${url}/managed`} />
    </Switch>
  )
}

function ScheduleManagementTabsRouter () {
  const { section } = useParams()
  return <ScheduleManagementTabs section={section} />
}

export default ScheduleManagement
